import { useEffect, useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { IMaskInput } from "react-imask";
import ReactLoading from "react-loading";
import * as S from "./styled";
//hooks
import useLoading from '../../../../hooks/useLoading';
import apiRequest from "../../../../hooks/apiRequest";
//Utils
import { checkCEP } from "utils/CheckCEP";
//Components
import ProgressBar from "../../../../components/ProgressBar";
import LayoutModal from "../../../LayoutModal";
//Icons
import { MagnifyingGlass } from "@phosphor-icons/react";

interface ICreate {
  isOpenModalAdress: boolean;
  setModalClose: () => void;
  idCustom: number | null;
}

type Inputs = {
  customer_id: number,
  cep: string,
  street: string,
  neighborhood: string,
  number: string,
  city: string,
  uf: string,
  complement: string,
  reference: string
};

export default function CreateAdress({
  isOpenModalAdress,
  setModalClose,
  idCustom
}: ICreate) {
  const {
    register,
    control,
    reset,
    handleSubmit: handleFormSubmit,
    formState: { errors },
    setValue
  } = useForm<Inputs>({
    shouldFocusError: false,
  });

  const [ isLoadSearch, setIsLoadSearch] = useState(false);
  const { isLoading, startLoading, stopLoading } = useLoading();
  const [inputValue, setInputValue] = useState('');
  const [dataAddress, setDataAddress] = useState<any>(null);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const response = await apiRequest('address', 'POST', { ...data, customer_id: idCustom });
      if (response.status === 201) {
        alert("Endereço criado com sucesso!");
        onClose();
      }
    } catch (error: any) {
      alert(error.message || "Ocorreu um erro ao criar o usuário.");
    } finally {
      stopLoading();
    }
  };

  const onClose = () => {
    setModalClose();
    reset();
  }

  useEffect(() => {
    try {
      if (dataAddress) {
        setValue('street', dataAddress.logradouro || '');
        setValue('neighborhood', dataAddress.bairro || '');
        setValue('city', dataAddress.localidade || '');
        setValue('uf', dataAddress.uf || '');
      }
    } catch (e) {
      console.log('error');
    }
  }, [dataAddress, setValue]); // Atualiza os campos quando dataAddress mudar

  if (isOpenModalAdress) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Registrar Endereço"
        subTitle="Cadastre um novo endereço em sua base de dados."
        setModalClose={onClose}
        submiteModal={handleFormSubmit(onSubmit)}
        nameCancel="Cadastrar depois">
        <S.ContentProgress>
          <ProgressBar name="Informações" />
          <ProgressBar name="Endereço" active={true} />
        </S.ContentProgress>
        <S.Container>
          <S.FormInput>
            <S.Label>
              CEP
              <span>*</span>
            </S.Label>
            <S.ContentInput>
              <Controller
                name="cep"
                rules={{ required: true }}
                control={control}
                render={({ field }) => (
                  <IMaskInput
                    id="cep"
                    mask="00.000-000"
                    placeholder="00.000-000"
                    onAccept={(value: string) => {
                      field.onChange(value);
                      setInputValue(value);
                    }}
                    {...field}
                    inputRef={field.ref}
                  />

                )}
              />
              {/* //Pesquisar */}
              <S.ButtonIcon
                onClick={() => checkCEP(inputValue, setDataAddress, setIsLoadSearch)}>
                {isLoadSearch ? (
                  <ReactLoading
                    type="spokes"
                    color="red"
                    height="20px"
                    width="20px"
                  />
                ) : (
                  <MagnifyingGlass size={20} />
                )}
              </S.ButtonIcon>
            </S.ContentInput>
            {errors.cep && (
              <S.InforErro>Campo Obrigatório</S.InforErro>
            )}
          </S.FormInput>

          <S.SeparateDiv>
            <S.FormInput>
              <S.Label>Cidade</S.Label>
              <S.Input
                type="text"
                placeholder="Informe a cidade"
                {...register("city")} />
            </S.FormInput>

            <S.FormInput>
              <S.Label>UF</S.Label>
              <S.Input type="text" placeholder="AM" {...register("uf")} />
            </S.FormInput>
          </S.SeparateDiv>

          <S.FormInput>
            <S.Label>Rua</S.Label>
            <S.Input type="text" placeholder="Informe a rua" {...register("street")} />
          </S.FormInput>

          <S.SeparateDiv>
            <S.FormInput>
              <S.Label>Bairro</S.Label>
              <S.Input type="text" placeholder="Informe a cidade" {...register("neighborhood")} />
            </S.FormInput>

            <S.FormInput>
              <S.Label>N°</S.Label>
              <S.Input type="text" placeholder="xxxx" {...register("number")} />
            </S.FormInput>
          </S.SeparateDiv>

          <S.FormInput>
            <S.Label>Referência</S.Label>
            <S.Input type="text" placeholder="Campo opcional" {...register("reference")} />
          </S.FormInput>

          <S.FormInput>
            <S.Label>Complemento</S.Label>
            <S.Input type="text" placeholder="Campo opcional" {...register("complement")} />
          </S.FormInput>
        </S.Container>
      </LayoutModal>
    );
  }
  return null;
}
